import styled from 'styled-components'

const H2 = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  margin-top: 70px;
  margin-bottom: 40px;
`

export default H2
